import * as React from 'react'
import {
  PieChart as PieChartComponent, Pie, ResponsiveContainer, Cell,
  Sector,
} from 'recharts'
import { Props, State } from './types'

import './styles.scss'
import { NoData } from '../NoData'
import FormatText from '../../helpers/FormatText'

export class PieChart extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      activeIndex: 0,
    }

    this.renderPercentage = this.renderPercentage.bind(this)
    this.renderChart = this.renderChart.bind(this)
    this.onPieEnter = this.onPieEnter.bind(this)
    this.displayPieChart = this.displayPieChart.bind(this)
  }

  renderActiveShape(props: any) {
    const RADIAN = Math.PI / 180;
    const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload } = props;

    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';

    return (
      <g>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={outerRadius + 6}
          outerRadius={outerRadius + 10}
          fill={fill}
        />
        <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
        <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
        <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} fontSize="12" textAnchor={textAnchor} fill="#333">{`${payload.name}`}</text>
        <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} fontSize="12" dy={18} textAnchor={textAnchor} fill="#999">
          {`(${FormatText.formatNumber(payload.value)}${payload.currency ? payload.currency : ''})`}
        </text>
      </g>
    );
  };

  onPieEnter(data: any, index: any) {
    this.setState({
      activeIndex: index,
    });
  }

  renderPercentage() {
    const { data } = this.props

    const sumElement = data
      .map((item: any) => item.value)
      .reduce((a: any, b: any) => a + b)

    return sumElement
  }

  renderChart(data: any) {
    return (
      <div style={{ height: '75%' }}>
        <ResponsiveContainer debounce={300}>
          <PieChartComponent>
            <Pie
              activeShape={this.renderActiveShape}
              activeIndex={this.state.activeIndex}
              data={data}
              dataKey="value"
              nameKey="name"
              innerRadius={60}
              outerRadius={80}
              fill="#FF1630"
              isAnimationActive={false}
              onMouseEnter={this.onPieEnter}
            >
              {
                data.map((entry: any, index: number) => (<Cell key={`cell-${index}`} fill={entry.color ? entry.color : "#FF1630"} />))
              }
            </Pie>
          </PieChartComponent>
        </ResponsiveContainer>
      </div>
    )
  }

  displayPieChart(data: any) {
    return data && data[1]?.value !== 100 && this.renderChart(data)
  }

  render() {
    const {
      data,
      style,
      title,
    } = this.props

    return (
      <section
        style={style}
        className="pieChart dashboardConfig col-xs-12"
      >
        <div className="pieChart__title">{title}</div>
        { Array.isArray(data) && data.length > 0 ? (
          this.displayPieChart(data)
        ) : <NoData />}
      </section>
    )
  }
}
